export default {
    title: 'Management rights',
    button: {
        edit: 'Edit management rights'
    }
}
